module.exports = __webpack_public_path__ + "img/6.f0c34a2f.png";